
import { Component, Vue } from "vue-property-decorator";
import GeneralFooter from "@/components/general-footer.vue";
import { Action, Mutation } from "vuex-class";
import { AuthenticatePayload } from "@/store/actions";
import { myJLSMappings } from "../constants/myJLSMappings";

@Component({
  components: {
    GeneralFooter,
  },
})
export default class Login extends Vue {
  // attributes //
  public username = "";
  public password = "";

  // store methods //
  @Action("myJLSAuthentication")
  myJLSAuthentication!: (payload: AuthenticatePayload) => Promise<void>;

  @Mutation("setUserName")
  setUserName!: (payload: string) => void;

  @Mutation("setBankName")
  setBankName!: (payload: string) => void;

  public async login(): Promise<void> {
    const loginPayload: AuthenticatePayload = {
      username: this.username,
      password: this.password,
    };

    this.setUserName(this.username);

    // Set default in case username is not found
    this.setBankName("undefined");

    // Search in mappings for username <=> bankName (=sequence_name)
    myJLSMappings.forEach((e) => {
      if (e.user == this.username) {
        this.setBankName(e.sequence_name);
      }
    });

    await this.myJLSAuthentication(loginPayload);
  }
}
